import React, { useEffect, useState } from 'react'

import { getBackendData } from '../../api/api'
import { IPOLStats } from '../../api/interfaces'
import { IChart, IChartConfig } from '../../components/Chart/interface'
import LoadingChart from '../../components/LoadingIcon/Loading'
import ChartPage from '../../pages/ChartPage/ChartPage'
import { useChartData } from '../../hooks/useChartData'
import { colors } from '../../const'

export async function getIncomePolDeploymentsConfig(color: string, inverseColor: string, timeframe: string) {
	const chartData = (await getBackendData('thorchain', 'tc_income_pol_stats', timeframe)) as IPOLStats[]
	const pools = [
		'ZEC.ZEC',
		'XRP.XRP',
		'TRON.USDT-TR7NHQJEKQXGTCI8Q8ZY4PL8OTSZGJLJ6T',
		'TRON.TRX',
		'BSC.USDT-0X55D398326F99059FF775485246999027B3197955',
		'BASE.USDC-0X833589FCD6EDB6E08F4C7C32D4F71B54BDA02913'
	]
	const assetData: IPOLStats[][] = []
	const seriesData: { x: number; y: number }[][] = []
	const config: IChart[] = []
	pools.forEach((pool) => {
		assetData.push(chartData.filter((row) => row.POOL_NAME === pool))
	})
	assetData.forEach((asset) => {
		seriesData.push(
			asset.map((element: IPOLStats) => {
				return { x: new Date(element.DAY).getTime() / 1000, y: element.TOTAL_DEPOSITED_RUNE - element.TOTAL_WITHDRAWN_RUNE }
			})
		)
	})
	const series1 = assetData[2].map((element: IPOLStats) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.TOTAL_CURRENT_VALUE_RUNE }
	})
	const series5 = (() => {
		const sumByDay = new Map<number, number>()

		for (const series of [seriesData[0], seriesData[1], seriesData[2], seriesData[3], seriesData[4]]) {
			for (const { x, y } of series) {
				sumByDay.set(x, (sumByDay.get(x) ?? 0) + y)
			}
		}

		return Array.from(sumByDay, ([x, y]) => ({ x, y })).sort((a, b) => a.x - b.x)
	})()
	config.push({
		data: series1,
		strokeWidth: 2,
		name: `Current Value`,
		type: 'line',
		seriesGroup: '[rune]',
		color: `${color}`,
		unitSymbol: 'ᚱ'
	})
	config.push({
		data: series5,
		strokeWidth: 2,
		name: `Total Deposited`,
		type: 'line',
		seriesGroup: '[rune]',
		color: `${colors[0]}`,
		unitSymbol: 'ᚱ'
	})
	let i = 0
	seriesData.forEach((series) => {
		config.push({
			data: series,
			strokeWidth: 2,
			name: pools[i].split('-')[0].toUpperCase(),
			type: 'line',
			seriesGroup: '[rune]',
			color: colors[i + 1],
			unitSymbol: 'ᚱ'
		})
		i++
	})

	return { config: config, latestValue: 0, latestValueDate: 0 }
}

const IncomePolDeployments = () => {
	const { dataSeries, timeframe, setTimeframe, isLoading, error, retry } = useChartData(getIncomePolDeploymentsConfig, '1d')

	if (error) {
		return (
			<div style={{ padding: 40, textAlign: 'center' }}>
				<p>Error loading chart: {error}</p>
				<button onClick={retry}>Retry</button>
			</div>
		)
	}

	if (isLoading || dataSeries === undefined) {
		return <LoadingChart />
	}
	return (
		<ChartPage
			chartTitle="Total Net Income POL Deployments"
			chartDesc={`Total Income POL deployments subtracted by withdrawals stacked by recipient pool. \n Tracking address: thor1fns25sytpf2gsdlg76g45620u5axm4mkrypqrh`}
			chartDescTitle="Metric Description"
			chartData={dataSeries.config}
			queryId="88fdb846-eb56-4576-bcf0-af576c4443e0"
			timeframe={timeframe}
			setTimeframe={setTimeframe}
			hasHours={false}
			hasLogScale={false}
			sortByValueDesc={true}
		/>
	)
}

export default IncomePolDeployments
